import { Component, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/index.css";
import { LanguageProvider } from "@/context/LanguageContext";
import { CartProvider } from "@/context/CartContext";
import { AnnouncementBar } from "@/components/AnnouncementBar";
import { Header } from "@/components/Header";
import { ReviewsBar } from "@/components/ReviewsBar";
import { CartDrawer } from "@/components/CartDrawer";
import { Footer } from "@/components/Footer";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { MetaRouteTracker } from "@/components/MetaRouteTracker";
import { CookieBanner } from "@/components/CookieBanner";
import Home from "@/pages/Home";
import ProductPage from "@/pages/ProductPage";
import { LegalPage } from "@/pages/LegalPage";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { err: false };
    }
    static getDerivedStateFromError() {
        return { err: true };
    }
    render() {
        if (this.state.err) {
            return (
                <div className="min-h-screen grid place-items-center bg-cream text-ink font-bold text-xl">
                    Algo salió mal · Something went wrong
                </div>
            );
        }
        return this.props.children;
    }
}

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};

function App() {
    return (
        <ErrorBoundary>
            <LanguageProvider>
                <CartProvider>
                    <BrowserRouter>
                        <ScrollToTop />
                        <MetaRouteTracker />
                        <CookieBanner />
                        <div className="page-x-lock" data-testid="page-x-lock">
                            <div className="sticky top-0 z-50">
                                <AnnouncementBar />
                                <Header />
                                <ReviewsBar />
                            </div>
                            <Routes>
                                <Route path="/" element={<Home />} />
                                <Route path="/regalo/:handle" element={<ProductPage />} />
                                <Route path="/legal/:doc" element={<LegalPage />} />
                                <Route path="/legal" element={<LegalPage />} />
                                <Route path="*" element={<Home />} />
                            </Routes>
                            <Footer />
                            <WhatsAppButton />
                        </div>
                        <CartDrawer />
                        <Toaster position="top-center" toastOptions={{ duration: 3000 }} />
                    </BrowserRouter>
                </CartProvider>
            </LanguageProvider>
        </ErrorBoundary>
    );
}

export default App;
